<template>
  <div>
    <el-select
      class="search-input"
      :value="value"
      v-model="result"
      :placeholder="placeholder"
      clearable
      :filterable="filterable"
      :remote="remote"
      :remote-method="remoteMethod"
      :loading="selectLoading"
      v-loadmore="loadMore"
      :disabled="disabled"
      @change="getSelected">
      <el-option
        v-for="item in selectList"
        :key="item[optionValue]"
        :label="item[optionName]"
        :value="item[optionValue]">
        <span v-html="optionContent" v-if="optionContent !== ''"></span>
      </el-option>
      <p v-if="noMore" class="noMore">暂无更多</p>
    </el-select>
  </div>
</template>

<script>
import qs from 'qs'
import selectFn from '@/api/selectPageFn'
export default {
  name: 'SelectPage',
  props: {
    // 是否可以模糊搜索
    remote: {
      type: Boolean,
      default: true
    },
    // 模糊搜索查询接口时输入字段的属性名
    remoteKey: {
      type: String,
      default: ''
    },
    // 是否可搜索
    filterable: {
      type: Boolean,
      default: true
    },
    // 初始值
    value: {
      type: String,
      default: ''
    },
    // 结果值的属性名，用于统一接收结果数据时回填
    valueName: {
      type: String,
      default: ''
    },
    // 请求时除了页码和单页数量其他数据
    requestData: {
      type: Object,
      default () {
        return {}
      }
    },
    requestUrl: {
      type: String,
      default: 'listAgentMerchant'
    },
    // 是否分页
    pagination: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '模糊搜索'
    },
    // 选项内容
    optionContent: {
      type: String,
      default: ''// 可以自定义option内容，html标签
    },
    optionName: {
      type: String,
      default: 'name'// 显示字段名
    },
    optionValue: {
      type: String,
      default: 'id'// id的字段名
    },
    pageSize: {
      type: Number,
      default: 50
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''// 显示字段名
    },
    // 初始化时根据id查询的属性名
    searchKey: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      result: '', // 选中的结果
      selectList: [],
      selectLoading: false,
      pageNo: 1,
      searchInput: '', // 搜索输入内容
      totalCount: 0, // 总条数
      noMore: false, // 是否还有更多
      initialed: false// 是否初始化完成
    }
  },
  watch: {
    value: {
      handler (val, oldVal) {
        this.result = val
        this.initialed = false
        this.checkInList()
      }
    },
    requestData: {
      handler (val, oldVal) {
        if (JSON.stringify(val) !== '{}' && JSON.stringify(val) !== JSON.stringify(oldVal)) {
          this.resetList()
        }
      },
      deep: true
    }
  },
  mounted () {
    if (JSON.stringify(this.requestData) !== '{}') {
      this.getList()
    }
  },
  methods: {
    resetList () {
      this.searchInput = ''
      if (this.pagination) {
        this.pageNo = 1
      }
      this.selectList = []
      this.noMore = false
      this.getList()
    },
    remoteMethod (queryString) {
      this.searchInput = queryString
      this.selectList = []
      if (this.pagination) {
        this.pageNo = 1
      }
      this.getList()
    },
    /**
             * 获取代理商下所有商户列表
             */
    getList () {
      this.selectLoading = true
      const that = this
      let params
      // 是否需要分页
      if (this.pagination) {
        params = Object.assign({}, {
          pageNo: that.pageNo,
          pageSize: that.pageSize
        }, that.requestData)
      } else {
        params = that.requestData
      }
      if (this.remote) {
        // 如果没有传搜索的键值，用option显示的属性名
        const key = this.remoteKey ? this.remoteKey : this.optionName
        params = Object.assign({}, params, {
          [key]: that.searchInput
        })
      }
      if (this.searchKey && !this.initialed) {
        params = Object.assign({}, params, {
          [this.searchKey]: that.value
        })
        this.initialed = true
      }
      params = qs.stringify(params)
      selectFn[this.requestUrl](params).then(response => {
        that.selectLoading = false
        if (parseInt(response.result_cde) === 0) {
          this.selectList = this.selectList.concat(response.data)
          this.totalCount = response.totalCount
          // console.log('selectPage:' + this.value);
          if (this.result !== '') {
            this.checkInList()
          }
        } else {
          this.selectLoading = false
          this.$message({
            message: response.result_msg,
            type: 'error'
          })
        }
      }).catch(() => {
        this.selectLoading = false
      })
    },
    getSelected (value) {
      const that = this
      let result = {}
      if (value !== '') {
        const item = this.selectList.filter((item) => { return item[that.optionValue] === value })
        result = {
          valueName: that.valueName,
          value: value,
          name: item[0][that.optionName]
        }
      } else {
        // 只有一条并且清空了，重新加载第一页
        // if(this.searchKey && this.selectList.length === 1 && this.searchInput === ''){
        //     if(this.pagination){
        //         this.pageNo = 1;
        //     }
        //     this.searchInput = '';
        //     this.selectList = [];
        //     this.getList();
        // }
        result = false
      }
      this.$emit('getSelect', result)
    },
    async loadMore () {
      if (!this.pagination) return
      if (!this.noMore && this.pageNo < Math.ceil(this.totalCount / this.pageSize)) {
        this.noMore = false
        this.pageNo++
        await this.getList()
      } else {
        this.noMore = true
      }
    },
    // 检查选中id是否在已加载列表中，加载后续分页，直到找到选中id对应的名称
    async checkInList () {
      const that = this
      const item = this.selectList.filter((item) => { return item[that.optionValue] === that.result })
      // 找不到就加载下一页
      if (item.length === 0) {
        // 如果支持用id查询，直接用id查，不行再分页
        if (this.searchKey !== '') {
          this.resetList()
        } else {
          if (!this.noMore) {
            await this.loadMore()
          } else {
            // this.$message({
            //     message: that.label + '初始化查找id失败！',
            //     type: 'error'
            // });
            console.log(that.label + '初始化查找id失败！')
          }
        }
      } else {
        this.initialed = true
      }
    }
  }
}
</script>

<style scoped>
    .noMore{
        font-size: 14px;
        color: #777;
        text-align: center;
        margin: 5px;
    }
</style>
